import { useToastsContext } from "@lending/hooks/useToasts";
import { useApi } from "@lending/lib/api";

const noop = () => Promise.resolve();

interface Props {
  onSuccess?: () => Promise<void> | void;
  onError?: (error: Record<string, unknown>) => void;
}
function usePutApplicationApplicantDetailsQuery({ onSuccess = noop, onError }: Props = {}) {
  const { clearToasts } = useToastsContext();
  const $api = useApi();

  return $api.useMutation("put", "/v2/lending/application_applicant_details/{uuid}/", {
    onSuccess: async () => {
      clearToasts();
      await onSuccess();
    },
    onError,
  });
}

export { usePutApplicationApplicantDetailsQuery };
